/**
 * This file deals with a Google Analytics global, which may or may not be injected by the
 * application host.
 */

export enum AnalyticsAction {
  SELECT_CERTIFICATION = 'select-certification',
  SELECT_LANGUAGE = 'select-language',
  SELECT_METHOD = 'select-method',
  SELECT_LOCATION = 'select-location',
  SELECT_BOOKING_METHOD = 'select-booking-method',
  SELECT_EXAM_COUNTRY = 'select-exam-country',
  SELECT_EXAM_CENTER = 'select-exam-center',
  SELECT_TRAINING_LANGUAGE = 'select-training-language',
  SELECT_TRAINING_COMPLETE = 'select-training-complete',
}

export function sendAnalyticsData(action: AnalyticsAction, label?: string | null) {
  // @ts-ignore
  const ga = window[window['GoogleAnalyticsObject'] || 'ga'];

  if (typeof ga === 'function') {
    try {
      // @ts-ignore
      ga.getAll()[0].send('event', 'get-certified', action, label);
    } catch (e: any) {
      console.error(`📊 Google Analytics failed:\n\t${e.message}`);
    }
  } else {
    // You should only see this during development;
    console.log(`📊 Google Analytics not recorded:\n\t${action}\n\t${label}`);
  }
}
